export default __webpack_public_path__ + "static/media/bgcourses_techAtLocation.d953fefd.png";